(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animal-of-the-month"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('aotm-countdown')) return;

    class AotmCountdown extends HTMLElement {
      connectedCallback() {
        if (this.timer) clearInterval(this.timer);
        this.numberEls = {
          d: this.querySelector('[data-unit="d"]'),
          h: this.querySelector('[data-unit="h"]'),
          m: this.querySelector('[data-unit="m"]'),
          s: this.querySelector('[data-unit="s"]'),
        };
        this.endTime = this.computeEndTime();
        this.tick();
        this.style.visibility = 'visible';
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }

      // Shop UTC offset (e.g. "-0400") rendered by Liquid; falls back to the visitor's timezone.
      offsetMilliseconds() {
        const raw = (this.dataset.utcOffset || '').trim();
        const match = raw.match(/^([+-])(\d{2})(\d{2})$/);
        if (!match) return -new Date().getTimezoneOffset() * 60000;
        const sign = match[1] === '-' ? -1 : 1;
        return sign * (Number(match[2]) * 3600 + Number(match[3]) * 60) * 1000;
      }

      // Ends at 23:59:59 shop-local time on the configured date, or at the given
      // time when the date carries one (YYYY-MM-DD HH:MM), or on the last day of
      // the current month when no date is set.
      computeEndTime() {
        const offset = this.offsetMilliseconds();
        const explicit = (this.dataset.endDate || '').trim();
        const match = explicit.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
        let year, month, day;
        let hour = 23;
        let minute = 59;
        let second = 59;
        if (match) {
          year = Number(match[1]);
          month = Number(match[2]) - 1;
          day = Number(match[3]);
          if (match[4] !== undefined) {
            hour = Number(match[4]);
            minute = Number(match[5]);
            second = 0;
          }
        } else {
          const now = new Date(Date.now() + offset);
          year = now.getUTCFullYear();
          month = now.getUTCMonth();
          day = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
        }
        return Date.UTC(year, month, day, hour, minute, second) - offset;
      }

      tick() {
        const remaining = Math.max(0, this.endTime - Date.now());
        const values = {
          d: Math.floor(remaining / 86400000),
          h: Math.floor(remaining / 3600000) % 24,
          m: Math.floor(remaining / 60000) % 60,
          s: Math.floor(remaining / 1000) % 60,
        };
        for (const unit in values) {
          const el = this.numberEls[unit];
          if (!el) continue;
          const text = String(values[unit]).padStart(2, '0');
          if (el.textContent !== text) el.textContent = text;
        }
        if (remaining <= 0 && this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('aotm-countdown', AotmCountdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["donation-conservation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('donation-slideshow')) return;

    // Slides shown per device bucket, slides moved per arrow/dot step,
    // and whether a partial next slide peeks in (phones only).
    const SHOW = { mobile: 1, tablet: 2, laptop: 3, all: 5 };
    const SCROLL = { mobile: 1, tablet: 1, laptop: 1, all: 1 };
    const PARTIAL = { mobile: true, tablet: false, laptop: false, all: false };

    const deviceBucket = () => {
      const w = window.innerWidth;
      if (w <= 767) return 'mobile';
      if (w <= 1024) return 'tablet';
      if (w <= 1200) return 'laptop';
      return 'all';
    };

    class DonationSlideshow extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('[data-slider]');
        if (!this.slider) return;
        this.slides = Array.from(this.slider.querySelectorAll('[data-slide]'));
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');
        if (!this.slides.length) return;

        this.device = deviceBucket();
        this.currentIndex = 0;
        this.suppressScrollUpdate = false;

        this.onPrev = () => this.goRelative(-1);
        this.onNext = () => this.goRelative(1);
        this.onScroll = () => this.handleScroll();
        this.onResize = () => this.handleResize();
        this.onBlockSelect = (event) => this.handleBlockSelect(event);

        // Track which slides are inside the slider viewport.
        this.visibleObserver = new IntersectionObserver(
          (entries) => entries.forEach((entry) => entry.target.classList.toggle('is-visible', entry.isIntersecting)),
          { root: this.slider, threshold: 0.01 }
        );
        this.slides.forEach((slide) => this.visibleObserver.observe(slide));

        this.applySnapStops();
        this.buildDots();
        this.updateArrows();

        this.prevButton.addEventListener('click', this.onPrev, { passive: true });
        this.nextButton.addEventListener('click', this.onNext, { passive: true });
        this.slider.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        if (this.dataset.autoplay === 'true') {
          const speed = parseInt(this.dataset.speed, 10) || 3000;
          this.autoplayTimer = setInterval(() => this.autoAdvance(), speed);
        }
      }

      disconnectedCallback() {
        if (this.autoplayTimer) clearInterval(this.autoplayTimer);
        if (this.visibleObserver) this.visibleObserver.disconnect();
        clearTimeout(this.scrollTimer);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      totalDots() {
        const show = SHOW[this.device];
        const scroll = SCROLL[this.device];
        if (this.slides.length <= show) return 1;
        return Math.ceil((this.slides.length - show) / scroll) + 1;
      }

      activeDot() {
        const dot = Math.ceil(this.currentIndex / SCROLL[this.device]);
        return Math.min(dot, this.totalDots() - 1);
      }

      buildDots() {
        if (!this.dotsWrap) return;
        this.dotsWrap.replaceChildren();
        const count = this.totalDots();
        for (let i = 0; i < count; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => this.handleDotClick(i, dot));
          this.dotsWrap.appendChild(dot);
        }
        this.updateDots();
      }

      updateDots() {
        if (!this.dotsWrap) return;
        const active = this.activeDot();
        Array.from(this.dotsWrap.children).forEach((dot, i) => {
          dot.classList.toggle('active', i === active);
        });
      }

      updateArrows() {
        const show = SHOW[this.device];
        const total = this.totalDots();
        const active = this.activeDot();
        if (this.slides.length <= show) {
          this.nextButton.style.visibility = 'hidden';
          this.prevButton.style.visibility = 'hidden';
        } else if (active >= total - 1) {
          this.nextButton.style.visibility = 'hidden';
          this.prevButton.style.visibility = '';
        } else if (active === 0) {
          this.nextButton.style.visibility = '';
          this.prevButton.style.visibility = 'hidden';
        } else {
          this.nextButton.style.visibility = '';
          this.prevButton.style.visibility = '';
        }
      }

      applySnapStops() {
        const scroll = SCROLL[this.device];
        this.slides.forEach((slide, i) => {
          slide.style.scrollSnapStop = i % scroll === 0 ? 'always' : '';
        });
      }

      updateIndexFromScroll() {
        const visible = this.slides.filter((slide) => slide.classList.contains('is-visible'));
        let index = this.slides.findIndex((slide) => slide.classList.contains('is-visible'));
        if (PARTIAL[this.device] && (visible.length >= SHOW[this.device] + 2 || index > 0)) index += 1;
        this.currentIndex = index < 0 ? 0 : index;
      }

      handleScroll() {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const suppress = this.suppressScrollUpdate;
          if (!suppress) this.updateIndexFromScroll();
          this.updateArrows();
          if (!suppress) this.updateDots();
          this.suppressScrollUpdate = false;
        }, 100);
      }

      handleResize() {
        const bucket = deviceBucket();
        if (bucket === this.device) return;
        this.device = bucket;
        this.applySnapStops();
        this.buildDots();
        this.updateArrows();
      }

      handleDotClick(dotIndex, dot) {
        Array.from(this.dotsWrap.children).forEach((child) => child.classList.remove('active'));
        dot.classList.add('active');
        const target = dotIndex * SCROLL[this.device];
        this.currentIndex = target;
        this.suppressScrollUpdate = true;
        this.goToSlide(target);
      }

      goRelative(direction) {
        const scroll = SCROLL[this.device];
        if (direction < 0 && this.nextButton.style.visibility === 'hidden') this.updateIndexFromScroll();
        const max = this.slides.length - scroll;
        let target = this.currentIndex + direction * scroll;
        if (target > max) target = max;
        if (target < 0) target = 0;
        this.currentIndex = target;
        this.updateDots();
        this.suppressScrollUpdate = true;
        this.goToSlide(target);
      }

      autoAdvance() {
        const scroll = SCROLL[this.device];
        const max = this.slides.length - scroll;
        const target = this.currentIndex >= max ? 0 : Math.min(this.currentIndex + scroll, max);
        this.currentIndex = target;
        this.updateDots();
        this.suppressScrollUpdate = true;
        this.goToSlide(target);
      }

      goToSlide(index) {
        const slide = this.slides[index];
        if (!slide) return;
        const left = Math.max(0, Math.min(slide.offsetLeft, this.slider.scrollWidth));
        this.slider.scroll({ left, behavior: 'smooth' });
      }

      handleBlockSelect(event) {
        const index = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
        if (index < 0) return;
        this.currentIndex = index;
        this.updateDots();
        this.updateArrows();
        this.suppressScrollUpdate = true;
        this.goToSlide(index);
      }
    }

    customElements.define('donation-slideshow', DonationSlideshow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
